<template>
    <be-card divider border-color="primary" class="user-info-list df-solution break-inside-avoid">
        <template slot="top">
            <div class="df-solution__image">
                <df-youtube class="card-img-top" :youtube-id="solution.youtubeId" v-if="solution.youtubeId"/>
                <img class="card-img-top" :src="solution.screenshot" loading="lazy" v-else>
            </div>
        </template>

        <div slot="header">
            <div class="tools offset-1" v-if="!!$slots.tools"><slot name="tools"/></div>
            {{ solution.title }}
            <span class="card-subtitle">Stand vom {{ solution.readableUpdatedAt }}</span>

            <p class="d-print-none mt-1" v-if="filterable">
                <button
                    class="btn btn-primary btn-xs btn-space"
                    v-for="(cat, k) in categories"
                    :key="k"
                    @click.prevent="$emit('filter-category', cat)"
                >{{cat.title}}</button>
                <button
                    class="btn btn-secondary btn-xs btn-space"
                    v-for="tag in solution.tags"
                    :key="tag"
                    @click.prevent="$emit('filter-tag', tag)"
                >{{tag}}</button>
            </p>
            <p class="d-print-none mt-1" v-else>
                <span class="badge badge-primary mr-1" v-for="(cat, k) in categories" :key="k">{{cat.title}}</span>
                <span class="badge badge-secondary mr-1" v-for="tag in solution.tags" :key="tag">{{tag}}</span>
            </p>
        </div>

        <dl class="df-solution__skills">
            <div class="df-solution__skills-row">
                <dt class="df-solution__skills-title"><span class="mdi mdi-plaster"></span> Nutzen</dt>
                <dd class="df-solution__skills-text">{{ solution.benefit }}</dd>
            </div>
            <div class="df-solution__skills-row">
                <dt class="df-solution__skills-title"><span class="mdi mdi-money-box"></span> Kosten</dt>
                <dd class="df-solution__skills-text">
                    <div v-if="solution.costsOneTime">einmalig {{ solution.onetimeCosts }}</div>
                    <div v-if="solution.costsRecurring">wiederkehrend {{ solution.recurringCosts }}</div>
                    <div v-if="solution.costsNotes">{{ solution.costsNotes }}</div>
                </dd>
            </div>
            <div class="df-solution__skills-row">
                <dt class="df-solution__skills-title"><span class="mdi mdi-time"></span> Zeitaufwand</dt>
                <dd class="df-solution__skills-text">
                    <span>{{ solution.timeNeededLabel }}</span>
                    <be-progress height="8px" :progress="solution.timeNeededInt"/>
                </dd>
            </div>
            <div class="df-solution__skills-row">
                <dt class="df-solution__skills-title"><span class="mdi mdi-pin"></span> Website<span class="icon s7-global"></span></dt>
                <dd class="df-solution__skills-text"><a :href="solution.website" target="_blank">{{ solution.readableWebsite }}</a></dd>
            </div>
        </dl>
    </be-card>
</template>

<script>
    import Solution from '../../models/Solution';

    import DfYoutube from './DfYoutube';

    export default {
        components: { DfYoutube },

        props: {
            solution: {
                type: Solution,
                required: true,
            },
            filterable: Boolean,
        },

        asyncComputed: {
            categories: {
                get: vm => vm.solution.getFrameworkCategories(),
                default: [],
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .df-solution {
        min-width: 320px;
        max-width: 500px;

        @media print {
            min-width: auto;
            max-width: none;
        }

        &__image {
            width: 100%;
            height: 0;
            padding-bottom: 100% / 16 * 9;
            background: url("../../assets/images/solution.svg") 0 0 no-repeat;
            background-size: cover;

            @if(env('VUE_APP_ENV') == 'heidiland') {
                background: url("../../assets/images/solution--heidiland.png") 0 0 no-repeat;
                background-size: cover;
            }
        }

        &__skills {
            &-row {
                display: flex;
                padding: 0 0 12px;
            }

            &-title {
                width: 40%;
                font-weight: inherit;

                .mdi {
                    margin-bottom: 1px;
                    margin-right: 10px;
                    font-size: 1.538rem;
                    vertical-align: middle;
                }
            }

            &-text {
                width: 60%;
                hyphens: auto;
            }

            @media print {
                &-row {
                    display: block;
                }

                &-title {
                    display: flex;
                    width: auto;
                    font-weight: bold;
                }

                &-text {
                    width: auto;
                }
            }
        }
    }
</style>
